import {
  MotionBox as Box,
  MotionGrid as Grid,
  viewAppearDefault,
  staggeredAppear,
} from "utils/motion";
import Trans from "components/base/Trans";
import FormSubscribe from "components/blocks/FormSubscribe";
import Text from "components/base/Text";
import Container from "components/base/Container";

const SubscribeSection = ({ model }) => (
  <Box
    width="100%"
    color="white"
    variants={staggeredAppear}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
  >
    <Box px={[6, null, 20]} variants={viewAppearDefault}>
      <Box bg="gray.800" h="1px" m="auto" maxWidth="xl" />
    </Box>
    <Box px={[0, null, 16]}>
      <Container
        position="relative"
        height="100%"
        maxWidth="xl"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={[6, 6, 0]}
      >
        <Grid
          width="100%"
          maxWidth={["468px", "614px", "614px", "100%"]}
          templateColumns={["1fr", "1fr", "1fr", "1fr 1.25fr", "1fr 1fr"]}
          gap={[6, null, null, 16]}
          py={16}
          alignItems="center"
          justifyItems={["center", "center", "start", "end"]}
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <Box variants={viewAppearDefault} width="100%">
            <Text color="white" type="headline_sm">
              <Trans id="LBL_FORM_SUBSCRIBE_TITLE" />
            </Text>
            <Text type="p_md" color="white" mt="12px" width="80%">
              <Trans
                id="LBL_FORM_SUBSCRIBE_SUBTITLE"
                values={{ model: model || "HX50" }}
              />
            </Text>
          </Box>
          <Box
            variants={viewAppearDefault}
            w="100%"
            maxWidth={["100%", null, null, "468px"]}
          >
            <FormSubscribe />
          </Box>
        </Grid>
      </Container>
    </Box>
  </Box>
);

export default SubscribeSection;
